function Construct()
{
    let css = require('./Construct.css');
    let globals = require('../config/globals.json');

    return (
        <div id="div_page">
            <div id="div_menu">
                <h2>Airport Selection</h2>
            </div>

            <div id="div_content" style={{ display:'block'}}>
	    
                <ul>
                {
                    globals.asSystems.map(sSystem => (
                        <li><a href={'?system=' + sSystem}>{sSystem.toUpperCase()}</a></li>
                    ))
                }
                </ul>
            </div>

            <div id="div_footer">
                <p id="footer_text">Construct</p>
                <img id="img_passur" src='/PASSUR.png' height="32px"></img>
            </div>
        </div>
    );
}

export default Construct

